import { api } from "@/lib/api-client";
import type { StoreListItem, ListStoresParams } from "@/types";

function favoritesQs(params?: ListStoresParams): string {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.limit) qs.set("limit", String(params.limit));
  if (params?.search) qs.set("search", params.search);
  if (params?.sortBy) qs.set("sortBy", params.sortBy);
  if (params?.sortOrder) qs.set("sortOrder", params.sortOrder);
  if (params?.template) qs.set("template", params.template);
  if (params?.status) qs.set("status", params.status);
  if (params?.appCategoryUlid) qs.set("appCategoryUlid", params.appCategoryUlid);
  if (params?.tagUlid) qs.set("tagUlid", params.tagUlid);
  if (params?.minRating) qs.set("minRating", String(params.minRating));
  const q = qs.toString();
  return q ? `?${q}` : "";
}

export const favoritesService = {
  list: (params?: ListStoresParams, token?: string) =>
    api.get<StoreListItem[]>(`/customer/favorites${favoritesQs(params)}`, { token }),

  add: (storeUlid: string, token?: string) =>
    api.post<void>(`/customer/favorites/${storeUlid}`, undefined, { token }),

  remove: (storeUlid: string, token?: string) =>
    api.delete<void>(`/customer/favorites/${storeUlid}`, { token }),
};
